import { provide } from 'vue'

import { schemaKey, valuesKey, errorsKey } from './symbols'

export const useFormProvider = ({ schema, values, errors }) => {
  provide(schemaKey, schema)
  provide(valuesKey, values)
  provide(errorsKey, errors)
}
